<template>
    <div class="main grid" :class="rootClasses">
        <div class="main--wrap">
            <div class="main--root">
                <transition-group name="trs-simple-fade" tag="div" class="main--inner">
                    <component v-for="(plugin, pluginIdx) in plugins"
                            :key="pluginIdx"
                            :is="plugin.type"
                            :position="pluginIdx"
                            :plugin="plugin">
                    </component>
                </transition-group>
            </div>
            <!-- <cmp-dot-loader class="main--loader" facet="main" :is-active="!plugins.length"></cmp-dot-loader> -->
        </div>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';
    import cmsPlaceholder from 'vue/mixins/cms/cms-placeholder';


    export default {
        mixins: [
            bemMixin('main'),
            cmsPlaceholder,
        ],
        computed: {
            rootClasses() {
                return [
                    this.bemFacet,
                    this.bemAdd(this.plugins.length ? '' : 'is-empty'),
                ];
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?3c5df97b